import { render, staticRenderFns } from "./PlatformInterconnectModal.vue?vue&type=template&id=b0d8ad3c&scoped=true&"
import script from "./PlatformInterconnectModal.vue?vue&type=script&lang=js&"
export * from "./PlatformInterconnectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d8ad3c",
  null
  
)

export default component.exports